import { render } from "./ContactViewPage.vue?vue&type=template&id=565ef8f5"
import script from "./ContactViewPage.vue?vue&type=script&lang=js"
export * from "./ContactViewPage.vue?vue&type=script&lang=js"
script.render = render

export default script